export default class WonTiedLost {
  constructor (data) {
    this.id = data.id
    this.name = data.name
  }
}
